/* Tea Top - vanilla JS controller
   Scoped entirely by data attributes inside [data-tt-root].
   Init is idempotent and re-runs on Shopify theme editor section events. */
(function () {
  'use strict';

  var FLAG = 'ttReady';

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = whole + '.' + parts[1];
    var amountNoDecimals = whole;

    if (!format) return '$' + amount;

    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case 'amount':
        case 'amount_with_comma_separator':
        case 'amount_with_period_separator':
          return amount;
        case 'amount_no_decimals':
        case 'amount_no_decimals_with_comma_separator':
        case 'amount_no_decimals_with_space_separator':
          return amountNoDecimals;
        default:
          return amount;
      }
    });
  }

  function hideNativeSubscriptionFallbacks() {
    if (!document.querySelector('[data-tt-root]')) return;

    var nativeSelectors = [
      '.shopify_subscriptions_app_block',
      '.shopify-subscriptions-app-block',
      '.shopify_subscriptions_app_container',
      '.shopify-subscriptions-app-container',
      '.shopify_subscriptions_purchase_option_wrapper',
      '.shopify_subscriptions_app_policy',
      '.subscriptions_app_embed_block'
    ];

    document.querySelectorAll(nativeSelectors.join(',')).forEach(function (node) {
      if (node.closest('[data-tt-root]')) return;
      node.hidden = true;
      node.style.display = 'none';
    });

    var candidates = Array.prototype.slice.call(
      document.querySelectorAll('div, section, form, fieldset, aside')
    );
    candidates
      .filter(function (node) {
        if (node.closest('[data-tt-root]')) return false;
        if (node.querySelector('[data-tt-root]')) return false;

        var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
        return text.indexOf('To edit the placement of the subscription widget') !== -1
          || text.indexOf('Subscription widget will only show on products') !== -1
          || (
            text.indexOf('One-time purchase') !== -1
            && text.indexOf('Subscribe and save') !== -1
            && text.indexOf('Deliver every') !== -1
          );
      })
      .forEach(function (fallback) {
        fallback.hidden = true;
        fallback.style.display = 'none';
      });
  }

  function watchNativeSubscriptionFallbacks() {
    if (window.__teaTopSubscriptionFallbackObserver) return;
    window.__teaTopSubscriptionFallbackObserver = true;

    hideNativeSubscriptionFallbacks();
    window.setTimeout(hideNativeSubscriptionFallbacks, 250);
    window.setTimeout(hideNativeSubscriptionFallbacks, 1000);
    window.setTimeout(hideNativeSubscriptionFallbacks, 2500);

    if (!window.MutationObserver) return;
    new MutationObserver(hideNativeSubscriptionFallbacks).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }

  function Section(root) {
    this.root = root;
    this.format = root.getAttribute('data-tt-money-format') || '';
    this.updateUrl = root.getAttribute('data-tt-update-url') === 'true';

    var json = root.querySelector('[data-tt-variants]');
    try {
      this.variants = json ? JSON.parse(json.textContent) : [];
    } catch (e) {
      this.variants = [];
    }

    this.selects = Array.prototype.slice.call(root.querySelectorAll('[data-tt-option-select]'));
    this.idInput = root.querySelector('[data-tt-variant-id]');
    this.priceEl = root.querySelector('[data-tt-price]');
    this.compareEl = root.querySelector('[data-tt-compare]');
    this.stockEl = root.querySelector('[data-tt-stock]');
    this.stockLabel = root.querySelector('[data-tt-stock-label]');
    this.addBtn = root.querySelector('[data-tt-add]');
    this.addContainer = root.querySelector('add-to-cart-component');
    this.addLabel = root.querySelector('[data-tt-add-label]');
    this.addPrice = root.querySelector('[data-tt-add-price]');
    this.qtyInput = root.querySelector('[data-tt-qty]');
    this.planWrap = root.querySelector('[data-tt-plan-wrap]');
    this.planSelect = root.querySelector('[data-tt-plan-select]');
    this.planInput = root.querySelector('[data-tt-plan-input]');
    this.onetimeMeta = root.querySelector('[data-tt-onetime-meta]');
    this.subscribeMeta = root.querySelector('[data-tt-subscribe-meta]');
    this.saveEl = root.querySelector('[data-tt-save]');
    this.modes = Array.prototype.slice.call(root.querySelectorAll('[data-tt-mode]'));

    this.slides = Array.prototype.slice.call(root.querySelectorAll('[data-tt-slide]'));
    this.thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-tt-thumb]'));

    this.bind();
    this.decorateOptions();
    this.update(false);
  }

  Section.prototype.bind = function () {
    var self = this;

    this.selects.forEach(function (select) {
      select.addEventListener('change', function () {
        self.update(true);
      });
    });

    this.modes.forEach(function (input) {
      input.addEventListener('change', function () {
        self.update(false);
      });
    });

    if (this.planSelect) {
      this.planSelect.addEventListener('change', function () {
        self.update(false);
      });
    }

    var dec = this.root.querySelector('[data-tt-qty-dec]');
    var inc = this.root.querySelector('[data-tt-qty-inc]');
    if (dec) dec.addEventListener('click', function () { self.stepQty(-1); });
    if (inc) inc.addEventListener('click', function () { self.stepQty(1); });
    if (this.qtyInput) {
      this.qtyInput.addEventListener('change', function () { self.normalizeQty(); });
      this.qtyInput.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowUp') { e.preventDefault(); self.stepQty(1); }
        if (e.key === 'ArrowDown') { e.preventDefault(); self.stepQty(-1); }
      });
    }

    this.thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        self.showSlide(parseInt(thumb.getAttribute('data-tt-thumb'), 10));
      });
      thumb.addEventListener('keydown', function (e) {
        var i = self.thumbs.indexOf(thumb);
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          var next = self.thumbs[(i + 1) % self.thumbs.length];
          next.focus();
          self.showSlide(parseInt(next.getAttribute('data-tt-thumb'), 10));
        }
        if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          var prev = self.thumbs[(i - 1 + self.thumbs.length) % self.thumbs.length];
          prev.focus();
          self.showSlide(parseInt(prev.getAttribute('data-tt-thumb'), 10));
        }
      });
    });

    var prev = this.root.querySelector('[data-tt-prev]');
    var next = this.root.querySelector('[data-tt-next]');
    if (prev) prev.addEventListener('click', function () { self.moveSlide(-1); });
    if (next) next.addEventListener('click', function () { self.moveSlide(1); });
  };

  /* ---------- Quantity ---------- */

  Section.prototype.normalizeQty = function () {
    if (!this.qtyInput) return;
    var min = parseInt(this.qtyInput.min, 10) || 1;
    var max = this.qtyInput.max ? parseInt(this.qtyInput.max, 10) : null;
    var n = parseInt(this.qtyInput.value, 10);
    if (isNaN(n) || n < min) n = min;
    if (max !== null && n > max) n = max;
    this.qtyInput.value = n;
  };

  Section.prototype.stepQty = function (delta) {
    if (!this.qtyInput) return;
    var min = parseInt(this.qtyInput.min, 10) || 1;
    var max = this.qtyInput.max ? parseInt(this.qtyInput.max, 10) : null;
    var step = parseInt(this.qtyInput.step, 10) || 1;
    var n = parseInt(this.qtyInput.value, 10);
    if (isNaN(n)) n = min;
    n = Math.max(min, n + (delta * step));
    if (max !== null) n = Math.min(max, n);
    this.qtyInput.value = n;
    this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  /* ---------- Gallery ---------- */

  Section.prototype.showSlide = function (index) {
    if (!this.slides.length) return;
    this.slides.forEach(function (slide) {
      var active = parseInt(slide.getAttribute('data-tt-slide'), 10) === index;
      slide.classList.toggle('is-active', active);
      if (active) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    });
    this.thumbs.forEach(function (thumb) {
      var active = parseInt(thumb.getAttribute('data-tt-thumb'), 10) === index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    this.index = index;
  };

  Section.prototype.moveSlide = function (delta) {
    var count = this.slides.length;
    if (!count) return;
    var current = typeof this.index === 'number' ? this.index : 0;
    this.showSlide((current + delta + count) % count);
  };

  /* ---------- Variants ---------- */

  Section.prototype.chosen = function () {
    return this.selects.map(function (select) {
      return select.value;
    });
  };

  Section.prototype.match = function (values) {
    for (var i = 0; i < this.variants.length; i++) {
      var variant = this.variants[i];
      var ok = true;
      for (var j = 0; j < values.length; j++) {
        if (variant.options[j] !== values[j]) { ok = false; break; }
      }
      if (ok) return variant;
    }
    return null;
  };

  /* Adds a price to every value of the first option and flags combinations
     that do not exist or are sold out. Runs on load and after each change. */
  Section.prototype.decorateOptions = function () {
    var self = this;
    var chosen = this.chosen();

    this.selects.forEach(function (select) {
      var index = parseInt(select.getAttribute('data-option-index'), 10) - 1;
      Array.prototype.forEach.call(select.options, function (option) {
        var value = option.getAttribute('data-option-value');
        if (value === null) return;
        var probe = chosen.slice();
        probe[index] = value;
        var variant = self.match(probe);
        var label = value;

        if (index === 0 && variant) {
          label += '  \u2014  ' + money(variant.price, self.format);
        }
        if (!variant) {
          label += ' (unavailable)';
        } else if (!variant.available) {
          label += ' (sold out)';
        }
        option.textContent = label;
      });
    });
  };

  Section.prototype.currentPlan = function (variant) {
    if (!variant || !variant.sellingPlans || !variant.sellingPlans.length) return null;
    if (this.planSelect) {
      var id = parseInt(this.planSelect.value, 10);
      for (var i = 0; i < variant.sellingPlans.length; i++) {
        if (variant.sellingPlans[i].id === id) return variant.sellingPlans[i];
      }
    }
    return variant.sellingPlans[0];
  };

  Section.prototype.syncPlanOptions = function (variant) {
    if (!this.planSelect) return;
    var plans = variant && variant.sellingPlans ? variant.sellingPlans : [];
    var selectedIsAvailable = false;

    Array.prototype.forEach.call(this.planSelect.options, function (option) {
      var optionId = parseInt(option.value, 10);
      var isAvailable = plans.some(function (plan) { return plan.id === optionId; });
      option.disabled = !isAvailable;
      option.hidden = !isAvailable;
      if (isAvailable && option.selected) selectedIsAvailable = true;
    });

    if (!selectedIsAvailable && plans.length) {
      this.planSelect.value = String(plans[0].id);
    }
  };

  Section.prototype.subscribing = function () {
    for (var i = 0; i < this.modes.length; i++) {
      if (this.modes[i].checked) return this.modes[i].value === 'subscribe';
    }
    return false;
  };

  Section.prototype.update = function (fromUser) {
    var variant = this.match(this.chosen());
    this.decorateOptions();

    this.syncPlanOptions(variant);
    var hasPlans = !!(variant && variant.sellingPlans && variant.sellingPlans.length);
    var subscribing = this.subscribing();
    if (!hasPlans && subscribing) {
      this.modes.forEach(function (input) { input.checked = input.value === 'onetime'; });
      subscribing = false;
    }
    var plan = this.currentPlan(variant);
    var unitPrice = subscribing && plan ? plan.price : variant ? variant.price : 0;

    if (this.idInput) this.idInput.value = variant ? variant.id : '';

    if (this.priceEl) this.priceEl.textContent = variant ? money(unitPrice, this.format) : '\u2014';

    if (this.compareEl) {
      var showCompare = !!(variant && variant.compareAtPrice && variant.compareAtPrice > variant.price);
      this.compareEl.hidden = !showCompare;
      if (showCompare) this.compareEl.textContent = money(variant.compareAtPrice, this.format);
    }

    var available = !!(variant && variant.available);
    if (this.stockEl) this.stockEl.classList.toggle('is-soldout', !available);
    if (this.stockLabel) {
      this.stockLabel.textContent = !variant ? 'Unavailable' : available ? 'In stock' : 'Sold out';
    }

    if (this.addBtn) this.addBtn.disabled = !available;
    if (this.addLabel) this.addLabel.textContent = !variant ? 'Unavailable' : available ? 'Add to cart' : 'Sold out';
    if (this.addPrice) this.addPrice.textContent = variant ? money(unitPrice, this.format) : '';
    if (this.addContainer && variant && variant.featuredMediaUrl) {
      this.addContainer.setAttribute('data-product-variant-media', variant.featuredMediaUrl);
    }

    if (this.qtyInput && variant) {
      this.qtyInput.min = variant.quantityMin || 1;
      this.qtyInput.step = variant.quantityIncrement || 1;
      if (variant.quantityMax === null) {
        this.qtyInput.removeAttribute('max');
      } else {
        this.qtyInput.max = variant.quantityMax;
      }
      this.normalizeQty();
    }

    // Selling plans
    if (this.modes.length) {
      this.modes.forEach(function (input) {
        var wrap = input.closest('[data-tt-mode-wrap]');
        if (input.value === 'subscribe') {
          input.disabled = !hasPlans;
          if (wrap) wrap.hidden = !hasPlans;
        }
        if (wrap) wrap.classList.toggle('is-active', input.checked);
      });

      if (this.onetimeMeta && variant) this.onetimeMeta.textContent = money(variant.price, this.format);
      if (this.subscribeMeta) {
        this.subscribeMeta.textContent = plan ? money(plan.price, this.format) + ' / delivery' : '';
      }
      if (this.saveEl) {
        var pct = plan && variant && plan.price < variant.price
          ? Math.round(((variant.price - plan.price) / variant.price) * 100)
          : 0;
        this.saveEl.hidden = pct === 0;
        this.saveEl.textContent = 'Save ' + pct + '%';
      }
      if (this.planWrap) {
        var showPlans = subscribing && variant && variant.sellingPlans.length > 1;
        this.planWrap.hidden = !showPlans;
      }
      if (this.planInput) {
        if (subscribing && plan) {
          this.planInput.disabled = false;
          this.planInput.value = plan.id;
        } else {
          this.planInput.disabled = true;
          this.planInput.value = '';
        }
      }
    }

    // Variant-linked media
    if (fromUser && variant && variant.featuredMediaPosition) {
      this.showSlide(variant.featuredMediaPosition - 1);
    }

    // Direct variant URLs
    if (fromUser && this.updateUrl && variant && window.history && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    this.root.dispatchEvent(
      new CustomEvent('tt:variant:change', { bubbles: true, detail: { variant: variant } })
    );
  };

  /* ---------- Init ---------- */

  function init(scope) {
    var roots = (scope || document).querySelectorAll('[data-tt-root]');
    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset[FLAG] === 'true') return;
      root.dataset[FLAG] = 'true';
      root.ttInstance = new Section(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      watchNativeSubscriptionFallbacks();
      init(document);
    });
  } else {
    watchNativeSubscriptionFallbacks();
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    hideNativeSubscriptionFallbacks();
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var roots = event.target.querySelectorAll('[data-tt-root]');
    Array.prototype.forEach.call(roots, function (root) {
      delete root.dataset[FLAG];
      root.ttInstance = null;
    });
  });

  document.addEventListener('shopify:section:select', function (event) {
    init(event.target);
  });
})();
